import { StackedBarFormat, StackedBarFormatColors } from '@/common/components/builder/organisms/Charts';
import { DateGroupOptionId, IConsentsOverview } from './StackedBarChart.types';
import { randomHexColor } from '@/common/utils/random';
import { getFirstDayOfWeek, getLastDayOfWeek } from '@/common/utils';

export const toStackedBarData = (data: IConsentsOverview[], dateGroupOption: DateGroupOptionId): StackedBarFormat[] => {
  return (
    data
      .map((item) => {
        const dataObj = item.values.reduce((acc, value) => {
          return {
            ...acc,
            ...{ [value.id]: value.value },
          };
        }, {});
        const isEmpty = Object.values(dataObj).length === 0;
        return {
          name: formatDate(item.groupValue, dateGroupOption),
          data: isEmpty ? null : dataObj,
        };
      })
      // this line is necessary because the linter is not able to detect that dataObj
      // have a specific operator that will return a StackedBarFormatData. If there are no
      // values we will return null. Then we filter those new values.
      // The lint is not to detect all of that. Is not the first time there is a problem with
      // the linter.
      .filter((item) => item.data !== null) as StackedBarFormat[]
  );
};

export const fixedColors = ['$blue300', '$green400', '$yellow300', '$darkBlue300', '$teal300', '$pink400'];
// This fn will return a list of colors for each bar in the chart
// except for the first 6 colors that are defined in the array above
export const getRandomColors = (data: IConsentsOverview[]): StackedBarFormatColors[] => {
  const allNamesMap = new Map<string, string>();
  data.forEach((item) => {
    item.values.forEach((value) => {
      allNamesMap.set(value.id, value.name);
    });
  });
  const allNames = Array.from(allNamesMap.keys());
  return allNames.map((id, index) => {
    return {
      id,
      name: allNamesMap.get(id) ?? '',
      color: index < 6 ? fixedColors[index] : randomHexColor(),
    };
  });
};

export const formatDate = (date: string, dateGroupOption: DateGroupOptionId): string => {
  const dateAsDate = new Date(date);
  switch (dateGroupOption) {
    case DateGroupOptionId.DAILY:
      return `${dateAsDate.getMonth() + 1}/${dateAsDate.getDate()}`;
    case DateGroupOptionId.WEEKLY:
    default: {
      const firstDay = getFirstDayOfWeek(dateAsDate);
      const lastDay = getLastDayOfWeek(dateAsDate);
      return `${firstDay.getMonth() + 1}/${firstDay.getDate()} - ${lastDay.getMonth() + 1}/${lastDay.getDate()}`;
    }
  }
};
